import { useEffect, useState } from "react";

const REVEAL_INTERVAL_MS = 320;

const prefersReducedMotion = (): boolean =>
  typeof window !== "undefined" &&
  typeof window.matchMedia === "function" &&
  window.matchMedia("(prefers-reduced-motion: reduce)").matches;

export function usePacedReveal(
  total: number,
  intervalMs: number = REVEAL_INTERVAL_MS,
): number {
  const [revealed, setRevealed] = useState(() =>
    prefersReducedMotion() ? Number.POSITIVE_INFINITY : total,
  );

  useEffect(() => {
    if (revealed >= total) return;

    const timer = setTimeout(
      () => setRevealed((shown) => shown + 1),
      intervalMs,
    );
    return () => clearTimeout(timer);
  }, [revealed, total, intervalMs]);

  return Math.min(revealed, total);
}
